// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yFCp3","colMin":"styles_colMin__19-cj"};